// import Vue from "vue";
import axios from "axios";

const getTranslations = (lang) => {
  return axios.get(window.app_config.translations[lang])
}

// const loadedLanguages = ['en'] // our default language that is preloaded
/*
 * @param choice {number} a choice index given by the input to $tc: `$tc('path.to.rule', choiceIndex)`
 * @param choicesLength {number} an overall amount of available choices
 * @returns a final choice index to select plural word by
*/

const slavic = ["ru"];

// VueI18n.prototype.getChoiceIndex = function(choice, choicesLength) {
//   // this === VueI18n instance, so the locale property also exists here
//   if (!slavic.includes(this.locale)) {
//     // proceed to the default implementation
//     choice = Math.abs(choice);

//     if (choicesLength === 2) {
//       return choice ? (choice > 1 ? 1 : 0) : 1;
//     }

//     return choice ? Math.min(choice, 2) : 0;
//   }

//   if (choice === 0) {
//     return 3;
//   }

//   const teen = choice > 10 && choice < 20;
//   const endsWithOne = choice % 10 === 1;

//   if (!teen && endsWithOne) {
//     return 0;
//   }

//   if (!teen && choice % 10 >= 2 && choice % 10 <= 4) {
//     return 2;
//   }

//   return choicesLength < 4 ? 2 : 3;
// };

const moduleStore = {
  namespaced: true,
  state: {
    keys: {},
    lang: 'en',
    fallbackLang: 'en'
  },
  mutations: {
    setKeys(state, {payload}) {
      const {lang, keys} = payload
      state.keys[lang] = {...state.keys[lang], ...keys}
    },
    setLang(state, {payload}) {
      state.lang = payload.lang
    },
  },
  getters: {
      keys: state => state.keys,
      lang: state => state.lang
  }
}

const TranslationPlugin = {
  install(Vue, {store}) {
    const moduleName = 'translationsModule'
    store.registerModule(moduleName, moduleStore)

    Vue.prototype.$t = function (key, params) {
      const lang = this.$store.getters[`${moduleName}/lang`]
      if (!lang) return key

      let keys = this.$store.getters[`${moduleName}/keys`][lang] || {}
      let str = keys[key]
      const defaultParams = this.$store.getters['accountModule/businessTerm']

      if (!str) {
        keys = this.$store.getters[`${moduleName}/keys`][this.$store.state[moduleName].fallbackLang]
        str = keys[key]
      }

      if (!str) return key

      if (!!params) {
        Object.keys(params).forEach(key => {
          if(key === 'angularKey') return;
          const replace = new RegExp( `{+${key}}+`, 'g');
          try {
            str = str.replace(replace, params[key].toString() || '')
          } catch {
            str = str.replace(replace, params[key] || '')
          }
        })
      }

      if (defaultParams) {
        Object.keys(defaultParams).forEach(key => {
          const replace = new RegExp(`{${key}}`, 'g');
          str = str.replace(replace, keys[defaultParams[key]] || '')
        })
        if(params && params.angularKey) {
          str = str.replace('{','').replace('}','');
        }
      }

      return str
    };

    Vue.prototype.$setKeys = function (lang, keys) {
      this.$store.commit({type: `${moduleName}/setKeys`, payload: {lang, keys}})
    };

    Vue.prototype.$setLang = function (lang) {
      this.$store.commit({type: `${moduleName}/setLang`, payload: {lang}})
    };

    Vue.prototype.$loadLang = async function (lang) {
      const keys = this.$store.getters[`${moduleName}/keys`]
      if (keys[lang]) return Promise.resolve()

      const res = await getTranslations(lang)
      res && store.commit({type: `${moduleName}/setKeys`, payload: {lang, keys: res.data}})
    };
  }
};

export default TranslationPlugin;
